import { useState } from 'react';
import { useOperatorListQuery } from '@common/cache';
import { useOperatorTableStore } from '../Filters/filters.store';
import { useDrawerStore } from 'store/drawer.store.ts';

export const useOperator = () => {
  const { filters } = useOperatorTableStore();
  const [selectedOperatorId, setSelectedOperatorId] = useState<string>('');

  const setDrawerOpen = useDrawerStore(state => state.setDrawerOpen);
  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  const {
    data = { count: 0, records: [] },
    isRefetching,
    isFetching,
  } = useOperatorListQuery(filters);

  const entries = data.records;

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedOperatorId('');
  };

  const handleOpenOperatorDetails = (id: string) => {
    setSelectedOperatorId(id);
    setDrawerOpen(true);
  };

  return {
    entries,
    totalCount: data.count,
    isInitialFilters:
      filters.search === '' &&
      filters.partner_id === '' &&
      filters.state === '' &&
      filters.county === '',
    isLoading: isRefetching || isFetching,
    handleCloseDrawer,
    handleOpenOperatorDetails,
    selectedOperatorId,
    isDrawerOpen,
  };
};
